<script setup>
import { onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import Footer from './footer/index.vue'
const router = useRouter()

const currentRouter = ref('/homePage')
const backgroundColor = ref('transparent')
const colorChange = ref(false)
const isHomeRouter = ref(true)
const activeNames = ref([])
const itemRef = ref(null)
const isHidden = ref(false)
// const isShowValue = ref(false);

watch(
  () => router,
  (newValue) => {
    const value = newValue.currentRoute.value.fullPath
    isHomeRouter.value = value === '/' || value === '/homePage' || value === '/#/homePage'
    currentRouter.value = value === '/' || value === '/#/homePage' ? '/homePage' : value
    if (value !== '/' && value !== '/homePage' && value !== '/#/homePage')
      colorChange.value = true
    else
      colorChange.value = false

    if (['/product/attractInvestment', '/product/goldenBrain'].includes(currentRouter.value))
      activeNames.value = ['2']
  },
  { immediate: true, deep: true },
)
const handleScroll = () => {
  const value = router.currentRoute.value.fullPath
  const scrollTop
    = document.documentElement.scrollTop
    || document.body.scrollTop
  // 设置背景颜色的透明度
  if (scrollTop && (!(scrollTop / 80 > 2) || (backgroundColor.value !== 'rgba(255, 255, 255,1)' && scrollTop > 80))) {
    backgroundColor.value = `rgba(255, 255, 255,${scrollTop / 80})`
    colorChange.value = true
  } else if (scrollTop === 0) {
    backgroundColor.value = 'transparent'
    if ((value === '/') || (value === '/homePage') || (value === '/#/homePage'))
      colorChange.value = false
  }
  // }
}
onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})
const jump = (path) => {
  if (path === router.currentRoute.value.fullPath) {
    isHidden.value = false
    itemRef.value.toggle()
    return
  }
  if (path !== '/' && path !== '/homePage' && (path !== '/#/homePage'))
    colorChange.value = false

  isHidden.value = false
  itemRef.value.toggle()
  router.push({
    path,
  })
}
const showSelector = () => {
  isHidden.value = true
}
const closeSelector = () => {
  // console.log('close selector')
  isHidden.value = false
}

const showDialog = () => {
  // 跳转到客服链接
  window.open('https://work.weixin.qq.com/kfid/kfc1de27190dee490b8')
}
</script>

<template>
  <div class="flex flex-col  w-full bg-white text-black flex-wrap min-h-screen">
    <!-- 导航条 -->
    <div class=" w-[100%] h-[80px]   flex flex-wrap  fixed z-40" :style="{ background: backgroundColor }">
      <div
        :class="colorChange ? 'colorChange' : ''"
        class="  w-[100%] h-[80px] px-[35px]  flex flex-none  justify-between items-center text-[rgba(255, 255, 255, 0.8)]  z-10 "
      >
        <div>
          <div class="w-[172px] h-[57px]  bg-contain  bg-center bg-no-repeat  logo" @touchend="jump('/homePage')" />
        </div>
        <div class="flex justify-center items-center">
          <div
            class="buttonTextIcon w-[160px] h-[50px] leading-[50px] text-center text-[26px]  text-white  mr-[30px]"
            @click="showDialog"
          >
            立即体验
          </div>
          <span class="wapNav text-[45px] text-white" :class="isHidden ? 'clicked' : 'notClicked'">
            <!-- <van-overlay :show="activeNames" @click="activeNames = false">
              <div class="wrapper" @click.stop>
                <div
                  class="h-[100px] text-[28px] text-[#333] leading-[100px] px-[30px] bg-[#F2F7FC]"
                  @click="jump('/product/goldenBrain')"
                >产业金脑</div>
                <div
                  class="h-[100px] text-[28px] text-[#333] leading-[100px] px-[30px] bg-[#F2F7FC]"
                  @click="jump('/product/industryResearch')"
                >数字产研</div>
                <div
                  class="h-[100px] text-[28px] text-[#333] leading-[100px] px-[30px] bg-[#F2F7FC]"
                  @click="jump('/product/attractInvestment')"
                >数智招商</div>
              </div>
            </van-overlay> -->

            <van-dropdown-menu>
              <van-dropdown-item ref="itemRef" title="" @open="showSelector" @close="closeSelector">
                <div class=" selector   ">
                  <div class="bg-white  w-[100%]   selectorItem  ">
                    <div
                      class="h-[100px] text-[30px] leading-[100px] px-[30px]"
                      :class="currentRouter === '/homePage' ? 'active-item' : 'text-[#333]'"
                      @touchend="jump('/homePage')"
                    >
                      首页
                    </div>
                    <div
                      class="h-[100px] text-[30px] leading-[100px] px-[30px]"
                      :class="currentRouter === '/product/industryResearch' ? 'active-item' : 'text-[#333]'"
                      @touchend="jump('/product/industryResearch')"
                    >
                      产业研究
                    </div>
                    <div>
                      <van-collapse v-model:model-value="activeNames">
                        <van-collapse-item name="2" :class="['/product/attractInvestment', '/product/goldenBrain'].includes(currentRouter) ? 'active-collapse' : ''">
                          <template #title>
                            <span :class="['/product/attractInvestment', '/product/goldenBrain'].includes(currentRouter) ? 'active-item' : 'text-[#333]'">产业招商</span>
                          </template>
                          <div
                            class="h-[100px] text-[28px] leading-[100px] px-[30px] bg-[#F2F7FC]"
                            :class="currentRouter === '/product/attractInvestment' ? 'active-item' : 'text-[#333]'"
                            @touchend="jump('/product/attractInvestment')"
                          >哒达招商</div>
                          <div
                            class="h-[100px] text-[28px] leading-[100px] px-[30px] bg-[#F2F7FC]"
                            :class="currentRouter === '/product/goldenBrain' ? 'active-item' : 'text-[#333]'"
                            @touchend="jump('/product/goldenBrain')"
                          >园区智服</div>
                        </van-collapse-item>
                      </van-collapse>
                    </div>

                    <div
                      class="h-[100px] text-[30px] leading-[100px] px-[30px]"
                      :class="currentRouter === '/toSea' ? 'active-item' : 'text-[#333]'"
                      @click="jump('/toSea')"
                    >
                      产业出海
                    </div>
                    <div
                      class="h-[100px] text-[30px] leading-[100px] px-[30px]"
                      :class="currentRouter === '/aboutUs/01' ? 'active-item' : 'text-[#333]'"
                      @click="jump('/aboutUs/01')"
                    >
                      关于我们
                    </div>
                  </div>
                </div>
              </van-dropdown-item>

            </van-dropdown-menu>
          </span>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <div class="flex-[1]  w-full  ">
      <div class="">
        <router-view />
      </div>
      <div v-if="router.currentRoute.value.matched[0]?.path !== '/consultUsForm/report'">
        <Footer @jump="jump" />
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import './index.less';

.buttonTextIcon {
  width: 160px;
  height: 50px;
  background: bottom / contain no-repeat url("https://static.idicc.cn/cdn/official/H5/home_btn_bg.png");
  background-size: 100% 100%;
}

.selector {

  // height: calc(100vh - 80px);
  .selectorItem {
    border-radius: 0px 0px 10px 10px;
  }

  .active-item {
    color: #1741CD !important;
    font-weight: 500;
  }
}

.dropdownText:global(.el-dropdown) {
  line-height: 28px !important;
  height: 28px;
}

.dropdownText:global(.el-dropdown .el-tooltip__trigger:focus-visible) {
  outline: 0px !important;
}

.dropdownText:global(.el-popper.is-light .el-popper__arrow::before) {
  display: none;
}
</style>

<style lang="less">
.colorChange {
  .notClicked {
    .van-dropdown-menu__bar {
      background: center / contain no-repeat url(../../assets/imgs/homes/navbar-color.png);
    }
  }

  .clicked {
    .van-dropdown-menu__bar {
      background: center / contain no-repeat url(../../assets/imgs/homes/close.png) !important;
    }
  }
}

.clicked {
  .van-dropdown-menu__bar {
    background: center / contain no-repeat url(../../assets/imgs/homes/close-white.png) !important;
  }

}

.notClicked,
.wapNav {
  .van-popup {
    border-radius: 0px 0px 10px 10px;
  }

  .van-dropdown-menu__bar {
    box-shadow: 0 0 0;
    width: 30px;
    height: 80px;
    background: center / contain no-repeat url(../../assets/imgs/homes/navbar.png);

    .van-dropdown-menu__title {
      display: none;
    }
  }
}

.selector {

  .van-cell {
    line-height: 100px;
    padding: 0 30px;
    height: 100px;
    font-size: 30px;
    color: #333333;

    .van-badge__wrapper {
      line-height: 100px;
      height: 100px;
      font-size: 30px;
    }
  }

  .van-collapse-item__content {
    padding: 0;
  }
}
</style>
0
